// store/index.js

import Vue from "vue";
import Vuex from "vuex";
import authModule from "../components/modules/auth";

Vue.use(Vuex);
export default new Vuex.Store({
    plugins: [
     
    ],
    state: {
      drawer: false,      
      loaded: false,
      videoIdFromFirebase: null,      
      video: { course: "", video: "", section: "" },
      alert: {
        type: "success",
        show: false,
        message: ""
      },
      pagination: {
        initialTab: null,
        haveFilter: null,
        filterIndex: null,
        filterValue: null
      }
    },
    getters: {
      drawer: state => {
        return state.drawer;
      }, 
      video:state => {
          return state.video
      },
      setInitialTabGetter (state) {
        return state.pagination.initialTab
      }
  
    },
    mutations: {
      setInitialTab(state, payload) {
        state.pagination.initialTab = payload;
      },
      setFilter(state, payload) {
        state.pagination.haveFilter = payload;
      },
      setValueFilter(state, payload) {
        state.pagination.filterIndex = payload.filterIndex;
        state.pagination.filterValue = payload.filterValue;
      },
      clearInitialTab(state, payload) {
        state.pagination.initialTab = 1;
      },
      clearAllPAgination(state){
        state.pagination.initialTab = null;
        state.pagination.filterIndex = null;
        state.pagination.haveFilter = null;
      },
      setVideo(state, payload) {
        state.video = payload;
      },
      changeDrawer(state, payload) {
        state.drawer = payload;
      },
      //mutacion para cargar la app
      setLoaded: (state, loaded) => {
        state.loaded = loaded;
      },
      setAlertMsg: (state, data) => {
        state.alert.type = data.type;
        state.alert.show = data.show;
        state.alert.message = data.message;
        setTimeout(() => {
          (state.alert.type = "success"),
            (state.alert.show = false),
            (state.alert.message = "");
        }, data.timeout);
      },
      setVideoIdFromFirebase: (state, id) => {
        state.videoIdFromFirebase = id;
      },
      clearVideoIdFromFirebase(state, payload) {
        state.videoIdFromFirebase = null;
      }
      
     
     
    },
    actions: {},
    modules: {
      authModule
    }
  });
  


// WEBPACK FOOTER //
// ./src/store/index.js